import { useTranslation } from 'react-i18next';
import { YouTubePlaylist } from '@codesweetly/react-youtube-playlist';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';

import { Container, DecoratedHeader } from '../../components';
import { usePortalSettings } from '../../hooks';
import { env } from '../../env';
import { StyledBoardContainer } from './Tutorials.styles';

const Tutorials: React.FC = () => {
  const { t } = useTranslation();
  const { item: portalSettingsData } = usePortalSettings();

  return (
    <Container>
      <DecoratedHeader
        icon={<PlayCircleOutlineOutlinedIcon />}
        title={t('pages.tutorials.pageTitle')}
        variant="colored"
      />

      <StyledBoardContainer>
        <YouTubePlaylist
          apiKey={env.REACT_APP_GOOGLE_API_KEY}
          playlistId={portalSettingsData?.playlistId ?? ''}
        />
      </StyledBoardContainer>
    </Container>
  );
};

export default Tutorials;
